var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.375 23.238c-.625 0-1.875-.25-2.5-.625-1.875 4.375-5.625 6.875-10 6.875-5.625 0-10.625-4.375-10.625-10-3.125-1.25-5-3.75-5-6.875C.25 8.238 4 4.488 8.375 4.488h3.1c.85 0 1.275.416 1.275 1.25h0c0 .833-.425 1.25-1.275 1.25h-3.1c-3 0-5.625 2.625-5.625 5.625 0 2.55 1.825 4.4 5.225 5.075-1.275 4.95 2.95 9.3 7.9 9.3 4.375 0 7.85-3.175 8.375-7.75.5.5 2 1.5 4.125 1.5 3.625 0 6.875-3.25 6.875-6.875S32 6.988 28.375 6.988h-1.85c-.85 0-1.275-.417-1.275-1.25h0c0-.834.425-1.25 1.275-1.25h1.85c5 0 9.375 4.375 9.375 9.375s-4.375 9.375-9.375 9.375zm-4.102-12.174c-.575.557-1.157.548-1.748-.026L19 7.513l-3.525 3.525s0 0 0 0c-.504.49-1.31.478-1.8-.026l-.002-.002c-.556-.574-.547-1.157.027-1.747l3.525-3.525L13.7 2.213s0 0 0 0c-.49-.505-.479-1.31.025-1.8l.002-.002c.575-.557 1.157-.548 1.748.027L19 3.963 22.525.438s0 0 0 0c.504-.49 1.31-.48 1.8.025l.002.002c.556.574.547 1.157-.027 1.748l-3.525 3.525L24.3 9.263s0 0 0 0c.49.504.479 1.31-.025 1.8l-.002.001z",
    transform: "translate(-169 -355) translate(169 356) matrix(1 0 0 -1 0 29.488)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDisconnected);
export default __webpack_public_path__ + "static/media/accountDisconnected.1cc79f96be4173edd522549c6b33a3d5.svg";
export { ForwardRef as ReactComponent };